
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 71.625 66.615"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.613 56.254c5.681 0 11.696-1.337 17.823-4.01 6.238-2.673 11.808-5.904 16.597-9.803 4.79-3.899 8.132-7.463 9.914-10.694.111 1.671.223 3.008.223 4.01.111 12.699-8.911 31.078-36.537 30.856-8.354-.446-15.818-2.005-22.613-4.79-3.008-1.225-5.681-2.562-8.02-4.01 3.008-5.458 6.238-10.471 9.691-14.815 8.132-10.582 16.597-17.377 25.286-20.608 5.235-1.894 10.137-2.896 14.704-2.896 3.676 0 7.018.557 10.025 1.782C63.159 16.709 65.721 9.58 67.503 0l4.122 1.003c-.334 4.01-.78 7.463-1.559 10.248-.668 2.785-2.005 6.906-4.122 12.476-1.671 4.567-5.347 9.134-10.805 13.924S43.443 46.34 36.536 49.459c-6.795 3.119-12.922 4.678-18.38 4.678l1.225 1.894c1.338.112 2.452.223 3.232.223z","fill":"currentColor"}})])
          )
        }
      }
    